import "./InvitationCard.css";
import type { FC, PropsWithChildren } from "react";
import { parseError } from "../common/error";
import { Spinner } from "../common/Spinner";
import { Card } from "../components/Card";
import InviteSvg from "./undraw_building_burz.svg?react";
import ErrorSvg from "./undraw_server-error_syuz.svg?react";
import { useInvitationSuspense } from "./useAuth";

interface InvitationCardProps extends PropsWithChildren {
	token: string;
	cta?: string;
}

const InvitationCard: FC<InvitationCardProps> = (props) => {
	const invitation = useInvitationSuspense(props.token);

	return (
		<Card>
			<Card.Body className="invitation-card-body">
				<InviteSvg />
				<div className="text">
					<h1>You have been invited to join {invitation.companyName}</h1>
					{props.cta && <h2>{props.cta}</h2>}
				</div>
			</Card.Body>
			{props.children}
		</Card>
	);
};

const InvitationCardError: FC<PropsWithChildren<{ error: unknown }>> = ({
	error,
	children,
}) => {
	const message = parseError(error) ?? "Unknown error";

	return (
		<Card>
			<Card.Body className="invitation-card-body error">
				<ErrorSvg />
				<div className="text">
					<h1>There is a problem with your invite</h1>
					<h2>{message}</h2>
					<h2>Please ask to be invited again.</h2>
				</div>
			</Card.Body>
			{children}
		</Card>
	);
};

const InvitationCardSuspense = () => {
	return (
		<Card>
			<Card.Body>
				<Spinner />
			</Card.Body>
		</Card>
	);
};

const InvitationCardNamespace = Object.assign(InvitationCard, {
	Error: InvitationCardError,
	Suspense: InvitationCardSuspense,
});

export { InvitationCardNamespace as InvitationCard };
